import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Login.vue';
import Errors from './views/Errors.vue';
import ForgotPassword from './views/ForgotPassword.vue';
import TokenPassword from './views/TokenPassword.vue';
import Default from './layouts/Default.vue';
import layoutRoutes from './router/layout';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      component: Default,
      children: layoutRoutes,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/mot-de-passe-oublie',
      name: 'forgot-password',
      component: ForgotPassword,
    },
    {
      path: '/mon-mot-de-passe/:token',
      name: 'change-password',
      component: TokenPassword,
    },
    {
      path: '/errors',
      name: 'errors',
      component: Errors,
    }, {
      path: '*',
      redirect: '/errors',
    },
  ],
});
